export default __webpack_public_path__ + "static/media/W_Aplus_True.e222444b.jpg";